import { createReducer } from 'redux-act';

import {
  CUSTOMER_FETCH_DATA_INIT,
  CUSTOMER_FETCH_DATA_SUCCESS,
  CUSTOMER_FETCH_DATA_FAIL,
  CUSTOMER_DELETE_INIT,
  CUSTOMER_DELETE_SUCCESS,
  CUSTOMER_DELETE_FAIL,
  CUSTOMER_CLEAR_DATA,
  CUSTOMER_CREATE_INIT,
  CUSTOMER_CREATE_SUCCESS,
  CUSTOMER_CREATE_FAIL,
  CUSTOMER_MODIFY_INIT,
  CUSTOMER_MODIFY_SUCCESS,
  CUSTOMER_MODIFY_FAIL,
  CUSTOMER_CLEAN_UP,
  CUSTOMER_CLEAR_DATA_LOGOUT
} from 'state/actions/customers';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const customersReducer = createReducer(
  {
    [CUSTOMER_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [CUSTOMER_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.users,
      loading: false,
      error: null
    }),
    [CUSTOMER_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CUSTOMER_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CUSTOMER_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [CUSTOMER_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CUSTOMER_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [CUSTOMER_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CUSTOMER_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload.user),
      loading: false,
      error: null,
      success: true
    }),
    [CUSTOMER_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CUSTOMER_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CUSTOMER_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return {
            firstName: payload.user.firstName,
            lastName: payload.user.lastName,
            phoneNumber: payload.user.phoneNumber,
            disabled: payload.user.disabled,
            id: payload.id,
            photoURL: payload.user.photoURL,
            createdAt: payload.user.createdAt,
            email: elem.email
          };
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [CUSTOMER_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CUSTOMER_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [CUSTOMER_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
